import {
  format as formatDate,
  formatDuration,
  formatISO,
  formatISODuration,
  intervalToDuration,
} from 'date-fns';
import * as locales from 'date-fns/locale';

type LocaleKey = keyof typeof locales;

const getLocale = (localeCode: string) => {
  const [languageCode, regionCode] = localeCode.split('_');

  if (languageCode === 'no') {
    return locales.nb;
  }

  if (locales[languageCode as LocaleKey]) {
    return locales[languageCode as LocaleKey];
  }

  const localeKey = `${languageCode}${regionCode}`;
  return locales[localeKey as LocaleKey] ?? locales.enGB;
};

export const getDurationAttributes = (localeCode: string, durationInSeconds: number = 0) => {
  const locale = getLocale(localeCode);

  const duration = intervalToDuration({
    start: 0,
    end: durationInSeconds,
  });

  return {
    ariaLabel: formatDuration(duration, { locale }),
    dateTime: formatISODuration(duration),
  };
};

const getFormattedDate = (
  localeCode: string,
  date: Date,
  format?: 'datetime' | 'date' | 'time',
) => {
  const locale = getLocale(localeCode);

  switch (format) {
    case 'date':
      return formatDate(date, 'PPPP', { locale });
    case 'time':
      return formatDate(date, 'p', { locale });
    default:
      return formatDate(date, 'PPPPp', { locale });
  }
};

export const getTimeAttributes = (
  localeCode: string,
  inputDate: string | number | Date,
  format?: 'datetime' | 'date' | 'time',
) => {
  const date = new Date(inputDate);

  return {
    ariaLabel: getFormattedDate(localeCode, date, format),
    dateTime: formatISO(date),
  };
};
